import { useEffect, useState } from "react";
import { Link, Routes, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes.consts";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Popover,
  PopoverBackdrop,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import Faq from "../../faq/faq";
import { useGetUsersListQuery } from "../../apis/userDetailsAPi";
import { isMobile } from "react-device-detect";
export const AuthHeaderLayout = ({
  auth,
  isDashboardPage,
  isSubmitPage,
}: {
  auth?: any;
  isDashboardPage?: any;
  isSubmitPage?: any;
}) => {
  const { data: creditsData, refetch: creditsRefetch } =
    useGetUsersListQuery<any>();

  const [openMenu, setOpenMenu] = useState(false);

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const location = useLocation();

  const navigate = useNavigate();

  const handleLogout = () => {
    window.localStorage.removeItem("id");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("userId");
    window.localStorage.removeItem("userName");
    window.localStorage.removeItem("userEmail");
    window.localStorage.removeItem("userCredits");
    window.localStorage.removeItem("refresh_token");
    window.localStorage.removeItem("dashboardSelectedTab");
    window.localStorage.removeItem("searchInput");
    window.sessionStorage.clear();
    navigate(ROUTES.HOME);
    setOpenMenu(false);
    document.body.classList.remove(location.pathname?.substring(1));
  };

  const userName = localStorage.getItem("userName");
  const userEmail = localStorage.getItem("userEmail");
  const UserProfileImage = localStorage.getItem("userProfileImage");

  const shouldShowBackButton =
    location.pathname.includes(ROUTES.FAQ) ||
    location.pathname.includes(ROUTES.CONTACT) ||
    location.pathname.includes(ROUTES.SITEMAP) ||
    location.pathname.includes(ROUTES.REVIEWS) ||
    location.pathname.includes(ROUTES.TERMS_AND_CONDITIONS) ||
    location.pathname.startsWith("/submit-public-page/");

  const isSubmitPageMobile =
    isMobile && location.pathname.startsWith("/submit-public-page/");

  const [isSidebarMenuOpen, setIsSidebarMenuOpen] = useState(false);
  const [iseHeaderSticky, setIsHeaderSticky] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsHeaderSticky(true);
      } else {
        setIsHeaderSticky(false);
      }
    });
  }, []);


  return (
    <header
      className={`${iseHeaderSticky ? "bg-[#020202]" : ""} ${
        !isSidebarMenuOpen ? "sticky top-0 left-0 z-[9]" : ""
      }  w-full transition-colors duration-300`}
    >
      <div className="container-1720 ">
        <div
          className={`main-wrapper-header flex items-center justify-between border-[#202027] ${
            shouldShowBackButton ||
            location.pathname.includes(ROUTES.TOP_CURATOR_CHART)
              ? "sm:border-b xl:border-b-0"
              : "border-b"
          }`}
        >
          <div className="flex items-center gap-8">
            <div
              className={`flex items-center gap-8 logo relative py-5 xl:py-4 after:!content-none border-solid border-[#202027] ${
                shouldShowBackButton ? "border-r-0" : "xl:border-r xl:w-[320px]"
              }`}
            >
              <a href="https://pitchplaylists.com/" className="block w-fit">
                <img
                  src="/image/logo.webp"
                  alt="Logo"
                  title="Logo"
                  loading="lazy"
                  width="230"
                  height="40"
                  className="xl:block hidden"
                />
                <img
                  src="https://pitchplaylists.com/blog/wp-content/uploads/2025/03/pitchplaylists-logo-mobile.png"
                  alt="Logo"
                  title="Logo"
                  width="40"
                  height="40"
                  loading="lazy"
                  className="xl:hidden object-contain block w-[40px] h-[40px]"
                />
              </a>
            </div>
            {location.pathname.includes(ROUTES.TOP_CURATOR_CHART) && (
              <h2 className="max-xl:hidden text-[28px] font-semibold">
                Top Curators Chart
              </h2>
            )}
            {location.pathname.includes(ROUTES.SETTINGS) && (
              <h2 className=" text-[28px] font-semibold max-xl:hidden "  >Account Settings</h2>
            )}

          </div>
         

          {shouldShowBackButton &&
            (!isMobile ||
              (isMobile &&
                !location.pathname.startsWith("/submit-public-page"))) && (
              <Link
                to="/"
                className="button button--white rounded-full  md:text-[15px] md:py-3 md:px-12 text-[13px] font-semibold py-[7px] px-[16px]"
              >
                Go To My Dashboard
              </Link>
            )}
          <div
            className={`flex items-center gap-3 ${
              !location.pathname.includes(ROUTES.FAQ) &&
              !location.pathname.includes(ROUTES.TERMS_AND_CONDITIONS) &&
              !location.pathname.includes(ROUTES.REVIEWS) &&
              !location.pathname.includes(ROUTES.CONTACT)
                ? ""
                : "hidden sm:flex"
            }`}
          >
            <Popover className="group relative">
              <PopoverBackdrop className="fixed inset-0 bg-[#052437]/20 backdrop-blur-[20px] z-10" />
              <PopoverButton
                className={`flex items-center gap-2.5 bg-[#878DA11A] border p-2 xl:px-3 xl:py-2.5 rounded-full group-data-[open]:z-20 relative overflow-visible ${
                  location.pathname.startsWith("/submit-public-page/")
                    ? "color-gradient-border"
                    : "border-none"
                }`}
                onClick={handleOpenMenu}
              >
                <div className="size-8 xl:size-10 rounded-full flex items-center justify-center overflow-hidden  ">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40ZM30 23C30 21.3431 28.6569 20 27 20H13C11.3431 20 10 21.3431 10 23V24C10 27.9429 13.719 32 20 32C26.281 32 30 27.9429 30 24V23ZM25.5 12.5C25.5 9.46243 23.0376 7 20 7C16.9624 7 14.5 9.46243 14.5 12.5C14.5 15.5376 16.9624 18 20 18C23.0376 18 25.5 15.5376 25.5 12.5Z"
                      fill="#878DA1"
                    />
                  </svg>
                </div>
                <span className="text-base text-[#fff] font-medium hidden xl:block">
                  {userName}
                </span>

                {shouldShowBackButton && (
                  <div className="flex gap-3 items-center ml-5">
                    <span className="text-[#fff]">
                      {creditsData?.user?.userCredits}
                    </span>
                    <span className="text-[18px] font-[500] text-[#4B4F55] leading-[26px]">
                      <img src="/image/green-star.webp" alt="Green Star" title="Green Star" width="16" height="15" loading="lazy" />
                    </span>
                  </div>
                )}

                {!shouldShowBackButton && (
                  <svg
                    className="text-[#fff] ml-[auto] xl:block hidden"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z"
                      fill="currentColor"
                    />
                  </svg>
                )}
              </PopoverButton>
              <PopoverPanel
                transition
                anchor="bottom end"
                className="mt-3 w-full !max-w-80 rounded-[20px] bg-profilePopover transition duration-200 ease-in-out data-[closed]:-translate-y-1 data-[closed]:opacity-0 p-5 z-20 max-sm:!left-1/2 max-sm:-translate-x-1/2"
              >
                {({ close }) => (
                  <>
                    <div className="flex items-start gap-3">
                      <div className="w-[48px] h-[48px] rounded-full flex items-center justify-center overflow-hidden">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 54 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M27.0002 53.6668C12.2726 53.6668 0.333496 41.7278 0.333496 27.0002C0.333496 12.2726 12.2726 0.333496 27.0002 0.333496C41.7278 0.333496 53.6668 12.2726 53.6668 27.0002C53.6668 41.7278 41.7278 53.6668 27.0002 53.6668ZM40.3335 31.0002C40.3335 28.791 38.5426 27.0002 36.3335 27.0002H17.6668C15.4577 27.0002 13.6668 28.791 13.6668 31.0002V32.3335C13.6668 37.5907 18.6255 43.0002 27.0002 43.0002C35.3748 43.0002 40.3335 37.5907 40.3335 32.3335V31.0002ZM34.3335 17.0002C34.3335 12.9501 31.0503 9.66683 27.0002 9.66683C22.9501 9.66683 19.6668 12.9501 19.6668 17.0002C19.6668 21.0503 22.9501 24.3335 27.0002 24.3335C31.0503 24.3335 34.3335 21.0503 34.3335 17.0002Z"
                            fill="#58F2A9"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-[#fff] font-[500] leading-[26px]">
                          {userName}
                        </p>
                        <p className="text-sm text-[#878DA1]">{userEmail}</p>
                      </div>
                    </div>

                    {location.pathname.startsWith("/submit-public-page/") ? (
                      <button
                        className="button button--white rounded-full w-full mt-6"
                        onClick={() => {
                          close();
                          navigate(ROUTES.DASHBOARD);
                        }}
                      >
                        Go to My Dashboard
                      </button>
                    ) : (
                      <button
                        className="button button--white rounded-full w-full mt-6"
                        onClick={() => {
                          close();
                          navigate(ROUTES.SETTINGS);
                        }}
                      >
                        My Account
                      </button>
                    )}

                    <button
                      className="button bg-transparent button--with-icon !gap-2 w-full font-normal mt-2"
                      onClick={() => handleLogout()}
                    >
                      <span className="text-white">Logout</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="!w-5 !h-5"
                      >
                        <path
                          d="M12.2999 18.9998C12.797 18.9998 13.1999 18.5969 13.1999 18.0998C13.1999 17.6028 12.797 17.1998 12.2999 17.1998H4.7999C3.47442 17.1998 2.3999 16.1253 2.3999 14.7998V5.19981C2.3999 3.87432 3.47442 2.7998 4.7999 2.7998H12.2999C12.797 2.7998 13.1999 2.39686 13.1999 1.8998C13.1999 1.40275 12.797 0.999805 12.2999 0.999805H4.7999C2.48031 0.999805 0.599902 2.88021 0.599902 5.19981V14.7998C0.599902 17.1194 2.48031 18.9998 4.7999 18.9998H12.2999ZM13.4894 5.43849C13.8547 5.10134 14.4241 5.12412 14.7612 5.48936L18.3612 9.38936C18.6795 9.73411 18.6795 10.2655 18.3612 10.6103L14.7612 14.5103C14.4241 14.8755 13.8547 14.8983 13.4894 14.5611C13.1242 14.224 13.1014 13.6546 13.4386 13.2894L15.6443 10.8998H6.2999C5.80285 10.8998 5.3999 10.4969 5.3999 9.99981C5.3999 9.50275 5.80285 9.09981 6.2999 9.09981H15.6443L13.4386 6.71026C13.1014 6.34502 13.1242 5.77563 13.4894 5.43849Z"
                          fill="#878DA1"
                          fillOpacity="0.6"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.3999 18.0998C13.3999 18.7073 12.9074 19.1998 12.2999 19.1998H4.7999C2.36985 19.1998 0.399902 17.2299 0.399902 14.7998V5.1998C0.399902 2.76975 2.36985 0.799805 4.7999 0.799805H12.2999C12.9074 0.799805 13.3999 1.29229 13.3999 1.8998C13.3999 2.50732 12.9074 2.9998 12.2999 2.9998H4.7999C3.58488 2.9998 2.5999 3.98478 2.5999 5.1998V14.7998C2.5999 16.0148 3.58488 16.9998 4.7999 16.9998H12.2999C12.9074 16.9998 13.3999 17.4923 13.3999 18.0998ZM13.3538 5.29153C13.8002 4.87946 14.4961 4.9073 14.9082 5.3537L18.5082 9.2537C18.8971 9.67507 18.8971 10.3245 18.5082 10.7459L14.9082 14.6459C14.4961 15.0923 13.8002 15.1202 13.3538 14.7081C12.9074 14.296 12.8796 13.6001 13.2916 13.1537L15.1875 11.0998H6.2999C5.69239 11.0998 5.1999 10.6073 5.1999 9.99981C5.1999 9.3923 5.69239 8.89981 6.2999 8.89981H15.1875L13.2916 6.84592C12.8796 6.39951 12.9074 5.70359 13.3538 5.29153ZM15.6443 9.09981H6.2999C5.80285 9.09981 5.3999 9.50275 5.3999 9.99981C5.3999 10.4969 5.80285 10.8998 6.2999 10.8998H15.6443L13.4386 13.2894C13.1014 13.6546 13.1242 14.224 13.4894 14.5611C13.8547 14.8983 14.4241 14.8755 14.7612 14.5103L18.3612 10.6103C18.6795 10.2655 18.6795 9.73411 18.3612 9.38936L14.7612 5.48936C14.4241 5.12412 13.8547 5.10134 13.4894 5.43849C13.1242 5.77563 13.1014 6.34502 13.4386 6.71026L15.6443 9.09981ZM13.1999 18.0998C13.1999 18.5969 12.797 18.9998 12.2999 18.9998H4.7999C2.48031 18.9998 0.599902 17.1194 0.599902 14.7998V5.19981C0.599902 2.88021 2.48031 0.999805 4.7999 0.999805H12.2999C12.797 0.999805 13.1999 1.40275 13.1999 1.8998C13.1999 2.39686 12.797 2.7998 12.2999 2.7998H4.7999C3.47442 2.7998 2.3999 3.87432 2.3999 5.19981V14.7998C2.3999 16.1253 3.47442 17.1998 4.7999 17.1998H12.2999C12.797 17.1998 13.1999 17.6028 13.1999 18.0998Z"
                          fill="#878DA1"
                          fillOpacity="0.6"
                        />
                      </svg>
                    </button>
                  </>
                )}
              </PopoverPanel>
            </Popover>

            {!shouldShowBackButton && (
              <button
                className={`size-12 p-0.5 rounded-2xl  xl:hidden  ${
                  isSidebarMenuOpen ? "relative z-20" : ""
                }`}
                style={{
                  backgroundImage:
                    "linear-gradient(90deg, rgba(88, 242, 169, 0.2) 0%, #58F2A9 100%)",
                }}
                onClick={() => setIsSidebarMenuOpen(true)}
              >
                <span className="h-full rounded-2xl flex items-center justify-center bg-[#0F1012]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                  >
                    <path
                      d="M1 1H17M1 11H17M1 6H17"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            )}

            <Dialog
              open={isSidebarMenuOpen}
              onClose={() => setIsSidebarMenuOpen(false)}
              className="relative z-10"
            >
              <DialogBackdrop
                className="fixed inset-0 bg-[#052437]/20 backdrop-blur-[20px]"
                onClick={() => setIsSidebarMenuOpen(false)}
              />
              <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel
                  className="p-3 w-full max-w-lg rounded-2xl"
                  style={{
                    backgroundImage:
                      "linear-gradient(180deg, #1c3941 0%, #0e0e10 59.5%)",
                    boxShadow: "0px 10px 40px 0px #060c1180",
                    marginTop: "-20%",
                  }}
                >
                  <p className="text-[#fff] text-center text-lg my-4">Menu</p>
                  <ul className="sidebar">
                    <li className="list-item mb-[2px]">
                      <Link
                        className={`list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px] ${
                          location.pathname === ROUTES.DASHBOARD ? "active" : ""
                        }`}
                        to={ROUTES.DASHBOARD}
                        onClick={() => setIsSidebarMenuOpen(false)}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M19.995 0.00012207H5.00832C1.99499 0.00012207 0.501648 1.5068 0.501648 4.5068V19.5068C0.501648 22.5068 1.99499 24.0001 5.00832 24.0001H19.995C23.0083 24.0001 24.5016 22.5068 24.5016 19.5068V4.5068C24.5016 1.5068 23.0083 0.00012207 19.995 0.00012207ZM18.5816 11.5201L11.2483 19.6668C11.1416 19.7735 11.0084 19.8401 10.875 19.8401C10.8084 19.8401 10.755 19.8268 10.6883 19.8001C10.5017 19.7201 10.3683 19.5468 10.3683 19.3335V13.3201H6.79494C6.59494 13.3201 6.42165 13.2001 6.34165 13.0134C6.26165 12.8401 6.28832 12.6268 6.42165 12.4801L13.755 4.33346C13.9017 4.17346 14.115 4.12011 14.315 4.20011C14.5016 4.28011 14.6349 4.45346 14.6349 4.66679V10.6801H18.2084C18.4084 10.6801 18.5816 10.8001 18.6616 10.9868C18.7416 11.1601 18.715 11.3735 18.5816 11.5201Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Dashboard
                        </span>
                      </Link>
                    </li>
                    <li className="list-item mb-[2px]">
                      <Link
                        className={`list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px] ${
                          location.pathname === ROUTES.SUBMIT_A_PLAYLIST
                            ? "active"
                            : ""
                        }`}
                        to={ROUTES.SUBMIT_A_PLAYLIST}
                        onClick={() => setIsSidebarMenuOpen(false)}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="27"
                            height="29"
                            viewBox="0 0 27 29"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M2.16846 14.0001C2.16846 7.74092 7.24256 2.66681 13.5018 2.66681C19.761 2.66681 24.8351 7.74092 24.8351 14.0001V16.6668H21.8351C21.2828 16.6668 20.8351 17.1145 20.8351 17.6668V26.3335C20.8351 26.8858 21.2828 27.3335 21.8351 27.3335H22.8351C25.0443 27.3335 26.8351 25.5426 26.8351 23.3335V14.0001C26.8351 6.63635 20.8656 0.666809 13.5018 0.666809C6.13799 0.666809 0.168457 6.63635 0.168457 14.0001V23.3335C0.168457 25.5426 1.95932 27.3335 4.16846 27.3335H5.16846C5.72074 27.3335 6.16846 26.8858 6.16846 26.3335V17.6668C6.16846 17.1145 5.72074 16.6668 5.16846 16.6668H2.16846V14.0001ZM14.5018 13.6668C14.5018 13.1145 14.0541 12.6668 13.5018 12.6668C12.9495 12.6668 12.5018 13.1145 12.5018 13.6668V27.6668C12.5018 28.2191 12.9495 28.6668 13.5018 28.6668C14.0541 28.6668 14.5018 28.2191 14.5018 27.6668V13.6668ZM9.16846 16.6668C9.72074 16.6668 10.1685 17.1145 10.1685 17.6668V23.6671C10.1685 24.2194 9.72074 24.6671 9.16846 24.6671C8.61617 24.6671 8.16846 24.2194 8.16846 23.6671V17.6668C8.16846 17.1145 8.61617 16.6668 9.16846 16.6668ZM18.8351 17.6668C18.8351 17.1145 18.3874 16.6668 17.8351 16.6668C17.2828 16.6668 16.8351 17.1145 16.8351 17.6668V23.6671C16.8351 24.2194 17.2828 24.6671 17.8351 24.6671C18.3874 24.6671 18.8351 24.2194 18.8351 23.6671V17.6668Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Add New Playlist
                        </span>
                      </Link>
                    </li>
                    <li className="list-item mb-[2px]">
                      <Link
                        className={`list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px] ${
                          location.pathname === ROUTES.SUBMIT_A_SONG
                            ? "active"
                            : ""
                        }`}
                        to={ROUTES.SUBMIT_A_SONG}
                        onClick={() => setIsSidebarMenuOpen(false)}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="27"
                            height="26"
                            viewBox="0 0 27 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M14.588 13.2631L4.54638 14.9367C4.31119 14.9759 4.11484 15.1378 4.03143 15.3611L0.56757 24.6377C0.236006 25.4902 1.12857 26.3036 1.94679 25.8945L25.9468 13.8945C26.6838 13.526 26.6838 12.4742 25.9468 12.1057L1.94679 0.105676C1.12857 -0.303433 0.236006 0.509956 0.56757 1.36255L4.03143 10.6391C4.11484 10.8624 4.31119 11.0243 4.54638 11.0635L14.588 12.7371C14.7333 12.7613 14.8314 12.8987 14.8072 13.0439C14.7885 13.1563 14.7004 13.2444 14.588 13.2631Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Submit a track
                        </span>
                      </Link>
                    </li>
                    <li className="list-item mb-[2px]">
                      <Link
                        className={`list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px] ${
                          location.pathname === ROUTES.TOP_CURATOR_CHART
                            ? "active"
                            : ""
                        }`}
                        to={ROUTES.TOP_CURATOR_CHART}
                        onClick={() => setIsSidebarMenuOpen(false)}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M20.8392 2.66681C22.3836 2.66681 23.6554 3.8338 23.8209 5.33406L25.5112 5.33348C26.7355 5.33348 27.7395 6.27629 27.8368 7.47544L27.8446 7.66681V11.6668C27.8446 13.9775 26.036 15.8658 23.7571 15.9933L23.4768 16.0011C22.5863 18.7881 20.1455 20.8822 17.1687 21.2691L17.1678 23.3335H19.5058C21.8165 23.3335 23.7048 25.1421 23.8323 27.4209L23.8392 27.6668V28.3335C23.8392 28.8397 23.463 29.2581 22.9749 29.3243L22.8392 29.3335H9.5018C8.99554 29.3335 8.57715 28.9573 8.51093 28.4692L8.5018 28.3335V27.6668C8.5018 25.3561 10.3104 23.4678 12.5892 23.3403L12.8351 23.3335H15.1678L15.1683 21.2686C12.1933 20.8803 9.75422 18.7868 8.86419 16.0011L8.82918 16.0001C6.43595 16.0001 4.49585 14.06 4.49585 11.6668V7.66681C4.49585 6.37814 5.54052 5.33348 6.82918 5.33348L8.52005 5.33406C8.6856 3.8338 9.95742 2.66681 11.5018 2.66681H20.8392ZM25.5112 7.33348H23.8392V13.9773C24.9059 13.8272 25.7411 12.9559 25.8357 11.8723L25.8446 11.6668V7.66681C25.8446 7.50901 25.7349 7.37683 25.5877 7.34228L25.5112 7.33348ZM8.5018 7.33348H6.82918C6.64509 7.33348 6.49585 7.48271 6.49585 7.66681V11.6668C6.49585 12.8444 7.36814 13.8182 8.5018 13.9774V7.33348Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Top Curators Chart
                        </span>
                      </Link>
                    </li>
                    <li className="list-item mb-[2px]">
                      <Link
                        className="list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px]"
                        to={ROUTES.BLOG}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M22.8351 5.33344C24.4229 5.33344 25.7227 6.56698 25.8282 8.12804L25.8351 8.33343V23.3334C25.8351 23.7016 26.1336 24.0001 26.5018 24.0001C26.8291 24.0001 27.1013 23.7643 27.1577 23.4533L27.1685 23.3334L27.1692 9.35183C28.5974 9.51007 29.7233 10.6709 29.8273 12.1148L29.8351 12.3334V22.3334C29.8351 24.6441 28.0265 26.5324 25.7477 26.6599L25.5018 26.6668H7.50179C5.19108 26.6668 3.3028 24.8582 3.17532 22.5793L3.16846 22.3334V8.33343C3.16846 6.74562 4.40201 5.44591 5.96306 5.34036L6.16846 5.33344H22.8351ZM12.8321 14.6668H8.16547C7.61319 14.6668 7.16547 15.1145 7.16547 15.6668V20.3334C7.16547 20.8857 7.61319 21.3334 8.16547 21.3334H12.8321C13.3844 21.3334 13.8321 20.8857 13.8321 20.3334V15.6668C13.8321 15.1145 13.3844 14.6668 12.8321 14.6668ZM20.8381 19.3334H17.507L17.3713 19.3426C16.8832 19.4088 16.507 19.8272 16.507 20.3334C16.507 20.8857 16.9547 21.3334 17.507 21.3334H20.8381L20.9738 21.3243C21.4619 21.2581 21.8381 20.8397 21.8381 20.3334C21.8381 19.7811 21.3904 19.3334 20.8381 19.3334ZM11.8321 16.6668V19.3334H9.16547V16.6668H11.8321ZM20.8363 14.6668L17.5052 14.6727L17.3696 14.6821C16.8816 14.7492 16.5061 15.1683 16.507 15.6745C16.508 16.2268 16.9565 16.6737 17.5088 16.6727L20.8399 16.6668L20.9756 16.6574C21.4636 16.5903 21.839 16.1712 21.8381 15.665C21.8371 15.1127 21.3886 14.6658 20.8363 14.6668ZM20.8381 10.0061H8.16547L8.02978 10.0152C7.54168 10.0814 7.16547 10.4998 7.16547 11.0061C7.16547 11.5584 7.61319 12.0061 8.16547 12.0061H20.8381L20.9738 11.9969C21.4619 11.9307 21.8381 11.5123 21.8381 11.0061C21.8381 10.4538 21.3904 10.0061 20.8381 10.0061Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Blog
                        </span>
                      </Link>
                    </li>
                    <li className="list-item mb-[2px]">
                      <Link
                        className={`list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px] ${
                          location.pathname === ROUTES.SETTINGS ? "active" : ""
                        }`}
                        to={ROUTES.SETTINGS}
                        onClick={() => setIsSidebarMenuOpen(false)}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M16.5184 3.00018C17.4971 3.01146 18.4719 3.12453 19.4271 3.33757C19.8441 3.43056 20.156 3.7782 20.2033 4.2028L20.4302 6.23859C20.5329 7.17333 21.3221 7.8813 22.263 7.88229C22.5159 7.88269 22.7661 7.83002 22.9998 7.72663L24.8673 6.90626C25.2557 6.73564 25.7095 6.82866 25.9994 7.13834C27.349 8.5797 28.3541 10.3084 28.9391 12.1943C29.0653 12.601 28.9201 13.0429 28.5773 13.2955L26.922 14.5156C26.4498 14.8626 26.171 15.4135 26.171 15.9995C26.171 16.5854 26.4498 17.1363 26.9231 17.484L28.5798 18.7046C28.9227 18.9572 29.0679 19.3992 28.9418 19.8059C28.357 21.6915 27.3525 23.42 26.0037 24.8616C25.714 25.1713 25.2605 25.2645 24.8722 25.0944L22.9971 24.2729C22.4606 24.0381 21.8445 24.0725 21.3376 24.3655C20.8306 24.6585 20.4932 25.1751 20.4288 25.7572L20.2034 27.7927C20.1569 28.2125 19.8517 28.5578 19.4409 28.6555C17.5096 29.115 15.4975 29.115 13.5662 28.6555C13.1554 28.5578 12.8503 28.2125 12.8038 27.7927L12.5787 25.7602C12.5126 25.1792 12.1747 24.6642 11.6681 24.3722C11.1615 24.0802 10.5465 24.0459 10.0118 24.2793L8.1363 25.101C7.74782 25.2712 7.29424 25.1779 7.00457 24.8681C5.65503 23.4248 4.65046 21.6942 4.06646 19.8066C3.94068 19.4 4.08601 18.9583 4.42866 18.7059L6.08643 17.4846C6.55862 17.1377 6.8375 16.5867 6.8375 16.0008C6.8375 15.4149 6.55862 14.8639 6.08582 14.5165L4.42908 13.2973C4.08593 13.0448 3.94046 12.6026 4.06669 12.1956C4.65169 10.3097 5.65679 8.58104 7.00636 7.13967C7.29632 6.82999 7.75011 6.73697 8.13852 6.9076L10.0057 7.72782C10.5429 7.96359 11.1606 7.92798 11.6699 7.63044C12.177 7.3363 12.5146 6.81915 12.5798 6.23704L12.8065 4.2028C12.8539 3.77798 13.166 3.43024 13.5833 3.33744C14.5396 3.12474 15.5155 3.01172 16.5184 3.00018ZM16.5018 12.0001C14.2927 12.0001 12.5018 13.791 12.5018 16.0001C12.5018 18.2093 14.2927 20.0001 16.5018 20.0001C18.7109 20.0001 20.5018 18.2093 20.5018 16.0001C20.5018 13.791 18.7109 12.0001 16.5018 12.0001Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Settings
                        </span>
                      </Link>
                    </li>
                    <li className="list-item mb-[2px]">
                      <Link
                        className={`list-item-link flex gap-[16px] items-center py-[14px] px-[15px] rounded-[10px] ${
                          location.pathname === ROUTES.FAQ ? "active" : ""
                        }`}
                        to={ROUTES.FAQ}
                        onClick={() => setIsSidebarMenuOpen(false)}
                      >
                        <span className="link-icon text-[#878DA199]">
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                          >
                            <path
                              d="M16.5018 2.66681C23.8656 2.66681 29.8351 8.63635 29.8351 16.0001C29.8351 23.3639 23.8656 29.3335 16.5018 29.3335C14.3145 29.3335 12.202 28.8054 10.3095 27.8112L4.58897 29.3006C3.98325 29.4584 3.36433 29.0952 3.20656 28.4895C3.15777 28.3022 3.15777 28.1055 3.20652 27.9183L4.69499 22.2005C3.69806 20.3059 3.16846 18.1905 3.16846 16.0001C3.16846 8.63635 9.13799 2.66681 16.5018 2.66681ZM16.5018 20.6668C15.7654 20.6668 15.1685 21.2638 15.1685 22.0001C15.1685 22.7365 15.7654 23.3335 16.5018 23.3335C17.2382 23.3335 17.8351 22.7365 17.8351 22.0001C17.8351 21.2638 17.2382 20.6668 16.5018 20.6668ZM16.5018 9.00014C14.4767 9.00014 12.8351 10.6418 12.8351 12.6668C12.8351 13.2191 13.2828 13.6668 13.8351 13.6668C14.3414 13.6668 14.7598 13.2906 14.826 12.8025L14.8437 12.4964C14.9291 11.656 15.6388 11.0001 16.5018 11.0001C17.4223 11.0001 18.1685 11.7463 18.1685 12.6668C18.1685 13.3852 17.9885 13.7405 17.3086 14.4431L16.9033 14.8554C15.8985 15.9014 15.5018 16.6525 15.5018 18.0001C15.5018 18.5524 15.9495 19.0001 16.5018 19.0001C17.0541 19.0001 17.5018 18.5524 17.5018 18.0001C17.5018 17.2817 17.6818 16.9265 18.3617 16.2239L18.7669 15.8116C19.7717 14.7655 20.1685 14.0145 20.1685 12.6668C20.1685 10.6418 18.5268 9.00014 16.5018 9.00014Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="link-text text-[#878DA1] text-lg font-medium">
                          Faq
                        </span>
                      </Link>
                    </li>
                  </ul>
                </DialogPanel>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </header>
  );
};
